import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { FiSearch } from 'react-icons/fi';

import { handleGetTravels } from '../../../../store/actionCreators/travels';

class Travels extends Component {
    state = {
        getError: {
            state: false,
            message: ""
        },
    }
    
    componentDidMount() {
        this.props.dispatch(handleGetTravels(this.props.match.params.id))
        .then(result => {
            if (result.error && result.error !== null) {
                this.setState({
                    getError: {
                        state: true,
                        message: result.error.message
                    }
                })
            } else {
            }
        })
    }

    render() {
        if (this.props.travels && this.props.travels !== null) {
            return (
                <div className="uni-supervisors p-2 p-lg-5 flex-grow-1">
                    <div className="pt-2 pb-2 px-3 m-1 m-lg-4 clearfix header-rec">
                        <h1 className="">خطوط النقل</h1>
                    </div>
                    <div className="my-2">
                        <div className="position-relative">
                            <input type="text" className="search-input" placeholder="البحث بواسطة رقم الخط" />
                            <FiSearch className="search-icon" color="rgb(50,157,135)" size="2rem" />
                        </div>
                    </div>
                    <div className="lines p-2 my-2 my-lg-4 d-flex flex-wrap align-content-start">
                        {this.props.travels.map(line => 
                            <div className="line-box p-2 my-2 w-100" key={line._id}>
                                <h4>{line.travel_start_name} - {line.travel_end_name} ({line.way==="go" ? "ذهاب" : "عودة"})</h4>
                                <div className="d-flex flex-wrap mb-3">
                                    {line.way_points.map(point =>
                                        <div className="line-box__one px-4 py-2 m-1" key={point.label+point.time}>
                                            <h5 className="mb-0">{point.label}</h5>
                                            <p className="mb-0">{point.time}</p>
                                        </div>
                                    )}
                                </div>
                                <div className="line-box__days my-3">
                                    <h5 className="mb-0">أيام عمل الخط</h5>
                                    <div className="d-flex flex-wrap">
                                        {line.work_days.map(day => 
                                            <div className="line-box__one px-4 py-2 m-1" key={day}>
                                                <h5 className="mb-0">{day}</h5>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="line-box__days my-3">
                                    <h5 className="mb-0">الحافلات على الخط</h5>
                                    <div className="d-flex flex-wrap">
                                        {line.bus.map(bus =>
                                            <div className="line-box__one px-4 py-2 m-1" key={bus._id}>
                                                <h5 className="mb-0">{bus.bus_identity}</h5>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <hr />
                            </div>
                        )}
                        
                    </div>
                </div>
            )
        } else {
            if (this.state.getError.state) {
                return (
                    <div className="m-5">
                        <div className="alert alert-danger text-center mb-5 fs-5" role="alert">
                            {this.state.getError.message}
                        </div>
                    </div>
                )
            } else {
                return (
                    <div className="text-center m-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )
            }
        }
    }
}

function mapStateToProps ({ travels }) {
	return {
		travels
	}
}

export default withRouter(connect(mapStateToProps)(Travels));